<template>
    <div class="bottom-up-products-summary-card w-100">
        <AonContainer>
            <AonRow class="mt-xl">
                <AonCol class="grid-cols-12">
                    <AonCard
                        title="Product List"
                        :desc="`Bottom-Up Product List for ${entityStore?.entity?.name}`"
                    >
                        <div class="card-content">
                            <AonCoverLoading
                                :loading="loading"
                                title="Gathering Company Products..."
                            ></AonCoverLoading>
                            <AonRow class="mt-xl h-100">
                                <AonCol class="grid-cols-12 h-100">
                                    <BottomUpProductSummaryTable
                                        v-if="props.data?.length > 0 && !loading"
                                        :tableData="props.data"
                                    />
                                </AonCol>
                            </AonRow>
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useEntityStore } from '@/stores'

import BottomUpProductSummaryTable from './BottomUpProductSummaryTable.vue'

const entityStore = useEntityStore()

const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    data: {
        type: Array,
        default: () => [],
    },
})
</script>
<style lang="scss" scoped>
.bottom-up-products-summary-card {
    position: relative;

    .card-content {
        height: 500px;
    }
}
</style>
